module.exports = __webpack_public_path__ + "static/media/LG.d9dbb6dc.png";